import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Drawer,
  Box,
  IconButton,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import {
  Close,
  ExpandMore,
  Apple,
  Android,
  X,
  Instagram,
  LinkedIn,
} from "@mui/icons-material";
import styles from "./MobileDrawer.module.css";

const MobileDrawer = ({ open, onClose }) => {

  const menuItems = [
    { name: "AI Background Remover", path: "/ai-background-remover" },
    { name: "AI Background Changer", path: "/ai-background-changer" },
    { name: "AI Image Enhancer", path: "/ai-image-enhancer" },
    { name: "AI Image Colorizer", path: "/ai-image-colorizer" },
    { name: "AI Super Resolution", path: "/ai-super-resolution" },
    { name: "AI Face Wrap", path: "/ai-face-wrap" },
    { name: "AI Selfie Generator", path: "/ai-selfie-generator" },
    { name: "AI Expand Images", path: "/ai-expand-images" },
    { name: "AI Image Generator", path: "/ai-image-generator" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          maxWidth: "320px",
          background: "rgba(21, 11, 42, 0.98)",
          backdropFilter: "blur(12px)",
          color: "white",
        },
      }}
    >
      <Box className={styles.container}>
        {/* Header Section */}
        <div className={styles.header}>
          <h1 className={styles.logo}>Remini.Ai</h1>
          <IconButton onClick={onClose} className={styles.closeButton}>
            <Close fontSize="large" />
          </IconButton>
        </div>

        {/* Main Content */}
        <div className={styles.content}>
          {/* Brand Section */}
          <div className={styles.brandSection}>
            <Button
              variant="contained"
              className={styles.launchButton}
              fullWidth
              component={Link}
              to="/dashboard"
            >
              Launch App
            </Button>
          </div>

          {/* Navigation Links */}
          <div className={styles.navigation}>
            {menuItems.map((item, index) => (
              <Button
                key={index}
                component={Link}
                to={item.path}
                onClick={onClose}
                className={styles.navButton}
                fullWidth
                sx={{
                  justifyContent: "flex-start",
                  color: "white",
                  textTransform: "none",
                  fontSize: "1rem",
                  py: 1.5,
                }}
              >
                {item.name}
              </Button>
            ))}
          </div>

          {/* Downloads Section */}
          <div className={styles.downloads}>
            <Button
              variant="contained"
              className={styles.downloadButton}
              startIcon={<Apple />}
              fullWidth
            >
              App Store
            </Button>
            <Button
              variant="contained"
              className={styles.downloadButton}
              startIcon={<Android />}
              fullWidth
            >
              Google Play
            </Button>
          </div>

          {/* Social Links */}
          <Divider className={styles.divider} />
          <div className={styles.socials}>
            <IconButton
              component="a"
              href="https://twitter.com"
              target="_blank"
              rel="noopener"
            >
              <X className={styles.socialIcon} />
            </IconButton>
            <IconButton
              component="a"
              href="https://instagram.com"
              target="_blank"
              rel="noopener"
            >
              <Instagram className={styles.socialIcon} />
            </IconButton>
            <IconButton
              component="a"
              href="https://linkedin.com"
              target="_blank"
              rel="noopener"
            >
              <LinkedIn className={styles.socialIcon} />
            </IconButton>
          </div>
        </div>
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;